var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 12,
    viewBox: "0 0 19 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6022 1.8828C18.4946 1.51945 18.285 1.19049 17.9958 0.930891C17.6984 0.66331 17.3339 0.471903 16.9367 0.374737C15.4502 0.00371678 9.49446 0.00371686 9.49446 0.00371686C7.0116 -0.0230321 4.52934 0.0946163 2.06171 0.355998C1.6645 0.460343 1.30068 0.656027 1.0026 0.925645C0.709726 1.19248 0.497588 1.52152 0.38677 1.88205C0.120563 3.24002 -0.00877903 4.61886 0.000488538 6C-0.00901018 7.37989 0.120014 8.75828 0.38677 10.1179C0.495214 10.477 0.70656 10.8045 1.00023 11.0691C1.2939 11.3337 1.6596 11.5248 2.06171 11.626C3.56805 11.9963 9.49446 11.9963 9.49446 11.9963C11.9805 12.0231 14.4659 11.9054 16.9367 11.644C17.3339 11.5468 17.6984 11.3554 17.9958 11.0878C18.2849 10.8283 18.4942 10.4993 18.6014 10.1359C18.8745 8.77849 19.0073 7.39907 18.9979 6.01723C19.0185 4.62955 18.8858 3.24363 18.6022 1.88205V1.8828ZM7.60105 8.5664V3.43434L12.5562 6.00075L7.60105 8.5664Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.adddbe9e66c0acb9118d013e28e2e54f.svg";
export { ForwardRef as ReactComponent };